// Re-export TradeWidget from shared so existing consumers
// (USDvPositionsPage, etc.) that import via this barrel keep working.
// TradeWidget itself was moved to packages/shared/src/widgets in
// Phase 1E of the external-consumption refactor.
export { TradeWidget } from "@solomon-apps/shared";
